import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {getSelectedDateRange, getAggregatedSites} from 'redux/modules/currentUser/selectors'
import {openReportAddModal} from 'redux/modules/ui/modal/actions'
import TopPanelMenu from 'components/TopPanelMenu'
import Link from 'components/Link'
import Limit from 'containers/Limit'

class AnalyticsViewMenu extends React.Component {
  static propTypes = {
    openReportAddModal: PropTypes.func.isRequired,
    startDate: PropTypes.instanceOf(Date),
    endDate: PropTypes.instanceOf(Date),
    dynamicDateType: PropTypes.string,
    dimensions: PropTypes.array,
    selectedSites: PropTypes.array,
    metrics: PropTypes.array,
    filters: PropTypes.object,
    charts: PropTypes.array,
    route: PropTypes.object,
    crossSiteMode: PropTypes.bool
  }

  static contextTypes = {
    permissions: PropTypes.object
  }

  render() {
    const {crossSiteMode} = this.props
    const {permissions} = this.context
    const prefix = crossSiteMode ? '/cross-site' : ''

    const ReportsMenuItem = permissions.show.includes('@features/reports') ? {
      to: `${prefix}/analytics/reports`,
      title: 'Reports',
      limitKey: 'reports'
    } : null

    return (
      <div className='analytics-view-menu'>
        <TopPanelMenu
          items={[
            {to: `${prefix}/analytics`, title: 'Analytics Explorer', limitKey: 'analytics', onlyActiveOnIndex: true},
            ReportsMenuItem
          ]}
        />
        {this.renderCreateButton()}
      </div>
    )
  }

  renderCreateButton() {
    const {route: {showReportButton}, crossSiteMode} = this.props
    const {permissions} = this.context
    const prefix = crossSiteMode ? '/cross-site' : ''

    if (!showReportButton || !permissions.show.includes('@features/createReport')) return null

    return (
      <Limit
        className='analytics-view-menu_button'
        limitKey='reports'
        action='create'
      >
        {permissions.create.includes('@features/reports')
          ? <button
            className='is-normal analytics-view-menu_button'
            onClick={this.onCreateReport}>
              Create Report
          </button>
          : <Link className='button is-normal' to={`${prefix}/analytics/reports`}>Create Report</Link>
        }
      </Limit>
    )
  }

  onCreateReport = () => {
    const {
      openReportAddModal,
      startDate,
      endDate,
      dynamicDateType,
      dimensions,
      metrics,
      filters,
      charts,
      selectedSites,
      crossSiteMode
    } = this.props

    openReportAddModal({
      startDate,
      endDate,
      dynamicDateType,
      dimensions,
      metrics,
      filters,
      selectedSites,
      charts
    }, crossSiteMode)
  }
}

const mapStateToProps = (state, props) => {
  const {startDate, endDate, dynamicDateType} = getSelectedDateRange(state)
  const {dimensions, metrics, filters, charts} = state.analytics
  const crossSiteMode = props.route.crossSiteMode
  const selectedSites = [].concat(getAggregatedSites(state, crossSiteMode))

  return {
    startDate,
    endDate,
    dynamicDateType,
    dimensions,
    metrics,
    filters,
    charts,
    selectedSites,
    crossSiteMode
  }
}

export default connect(mapStateToProps, {
  openReportAddModal
})(AnalyticsViewMenu)



// WEBPACK FOOTER //
// ./client/views/AnalyticsView/Menu.js